import React, { useState } from 'react';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { AssessmentContent } from './components/AssessmentContent';
import { AnalyticsDashboard } from './components/AnalyticsDashboard';
import { FeedbackPage } from './components/FeedbackPage';
import { AdminHub } from './pages/AdminHub';
import { ReportsPage } from './pages/ReportsPage';
import { UserManagementPage } from './pages/UserManagementPage';
import { ProfilePage } from './pages/ProfilePage';
import { SettingsPage } from './pages/SettingsPage';
import { AlertsPage } from './pages/AlertsPage';
import { BulkUploadResultsPage } from './pages/BulkUploadResultsPage';
import { InsightsActionsPage } from './pages/InsightsActionsPage';
import { GlobalPhoebeChat } from './components/GlobalPhoebeChat';
import { PhoebeOnboarding } from './components/PhoebeOnboarding';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ijxo6nd1puib">
      <div className="flex h-screen bg-gray-50" data-id="element-1" data-mp="3ikh9me1wn113">
        <Sidebar data-id="element-2" data-mp="3ijpet5g4t7bv" />
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3" data-mp="3ii4q3wgi0ilx">
          <Header data-id="element-4" data-mp="3mjzrt22ccy08" />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50" data-id="element-5" data-mp="3mjg8bgx1m1k3">
            <Routes data-id="element-6" data-mp="3rcsxbs5mwadd">
              <Route path="/" element={<Navigate to="/admin" replace data-id="element-8" data-mp="5orh0l86u6j" />} data-id="element-7" data-mp="3reltuemj9e7n" />
              <Route path="/admin" element={<AdminHub data-id="element-10" data-mp="7stfczkdj46" />} data-id="element-9" data-mp="5ghbgghm2z1" />
              <Route path="/analytics" element={<AnalyticsDashboard data-id="element-12" data-mp="2zmo557bmuj1l" />} data-id="element-11" data-mp="2zlld2w2kqak3" />
              <Route path="/assessment" element={<UserManagementPage data-id="element-14" data-mp="33lx0ggmbmoz9" />} data-id="element-13" data-mp="33mov9p83gioh" />
              <Route path="/feedback" element={<ReportsPage data-id="element-16" data-mp="38m1fs3bhtdnw" />} data-id="element-15" data-mp="33myix65o2dr0" />
              <Route path="/profile" element={<ProfilePage data-id="element-18" data-mp="38kglmet3bwqk" />} data-id="element-17" data-mp="38kqbm2e4y3w9" />
              <Route path="/settings" element={<SettingsPage data-id="element-20" data-mp="3dlw5i3jj7x7d" />} data-id="element-19" data-mp="3dkl42adk71jf" />
              <Route path="/alerts" element={<AlertsPage data-id="element-22" data-mp="nvsvva68mxyl" />} data-id="element-21" data-mp="3dm5vvs8ho6dl" />
              <Route path="/insights-actions" element={<InsightsActionsPage data-id="element-24" data-mp="sudlkfnv5z8s" />} data-id="element-23" data-mp="nuhh6fb985sp" />
              <Route path="/bulk-upload-results" element={<BulkUploadResultsPage data-id="element-26" data-mp="35ghusegjner" />} data-id="element-25" data-mp="sssqmoxn0eae" />
            </Routes>
          </main>
          <GlobalPhoebeChat data-id="element-27" data-mp="3ubrg6gs32a2e" />
          <PhoebeOnboarding data-id="element-28" data-mp="3ucjcjtti8btq" />
        </div>
      </div>
    </BrowserRouter>;
}
export { App };